import styled from 'styled-components';

export const ModalContentStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  .filter-tabs-container {
    .Polaris-Tabs__Outer > .Polaris-Box,
    .Polaris-Tabs.Polaris-Tabs--fitted {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;
